import './PageTabs.scss';

import { DefaultRouteKey, DefaultRoutes } from 'Routes';
import { Outlet, useNavigate } from 'react-router-dom';
import { Tab, Tabs } from '@trackman/web-shared-components';
import { ReactNode, useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface TabsProps<TabRoute extends DefaultRouteKey, TabName extends string> {
  tabs: { [key in TabRoute]: TabName };
  defaultTabName: TabName;
  children?: ReactNode;
}

export const PageTabs = <TabRoute extends DefaultRouteKey, TabName extends string>({
  tabs,
  defaultTabName,
  children,
}: TabsProps<TabRoute, TabName>) => {
  const [activeTabName, setActiveTabName] = useState<TabName>(defaultTabName);
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const tabNameFromLocation = location.pathname.split('/').at(-1) as TabRoute;
    const tabNameFromMainPartOfUrl = location.pathname.split('/').at(1) as TabRoute;

    setActiveTabName(
      tabs?.[tabNameFromLocation]
        ? tabs?.[tabNameFromLocation]
        : tabs?.[tabNameFromMainPartOfUrl]
        ? tabs?.[tabNameFromMainPartOfUrl]
        : defaultTabName
    );
  }, [location.pathname, tabs, defaultTabName]);

  return (
    <div className='tabs-content-container'>
      <div className='tabs-wrapper'>
        <Tabs scrollButtons value={activeTab} variant='scrollable' allowScrollButtonsMobile>
          {Object.entries(tabs as Record<TabRoute, TabName>).map(([tabRoute, tabName], index: number) => {
            return (
              <Tab
                key={tabRoute}
                className={`tabs-tab ${activeTabName === tabs[tabRoute] ? 'tab-active' : ''}`}
                label={t(tabName as TabName, { ns: 'aboutCertification' })}
                onClick={() => {
                  setActiveTab(index);
                  navigate(DefaultRoutes[tabRoute]);
                }}
              />
            );
          })}
        </Tabs>
        {children}
      </div>

      <Outlet />
    </div>
  );
};

export default PageTabs;
